import { createSlice, current } from "@reduxjs/toolkit";
import update from "react-addons-update";
import { FormattedMessage } from "react-intl";
import { openSnackbar } from "store/slices/snackbar";
import axios from "utils/axios";
import { getErrorCode } from "utils/errors";
import { dispatch } from "../index";

const initialState = {
  isContestantsLoading: true,
  isErrorContestants: false,
  contestants: null,
  isPatchingContestant: false,
  isPostingContestant: false,
  isDeletingContestant: false,
  isUpsertingContestants: false,
  isDeletingAllContestants: false,
  isDeletingAllContestantsFailure: false,
  isDeletingAllContestantsSucceeded: false,
  isErasingContestant: false,
  insertedContestants: [],
  updatedContestants: [],
  notUpsertedContestants: [],
  page: 0,
  limit: 100,
  // ==== modalContestant ====
  contestant: {
    id: null,
    openModal: false,
    isLoading: false,
    data: null,
    error: null,
  },
};

const slice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    getContestants(state, page) {
      state.isContestantsLoading = true;
      state.isErrorContestants = false;
      state.page = page;
      state.contestants = null;
    },
    setPaginationParams(state, action) {
      state.params = action.payload;
    },
    getContestantsSuccess(state, action) {
      state.isContestantsLoading = false;
      state.isErrorContestants = false;
      state.contestants = action.payload.data;
      state.totalContestantsCount = action.payload.total_count;
      state.page = action.payload.request.offset;
      state.limit = action.payload.request.limit;
    },
    getContestantsError(state, action) {
      state.isContestantsLoading = false;
      state.isErrorContestants = true;
      state.contestants = null;
    },
    patchContestant(state) {
      state.isPatchingContestant = true;
    },
    patchContestantSuccess(state, action) {
      state.isPatchingContestant = false;
      const index = state.contestants.findIndex(
        (c) => c.id === action.payload.id
      );

      state.contestants = update(state.contestants, {
        [index]: {
          $set: action.payload,
        },
      });
      state.contestant = action.payload;
    },
    patchContestantFailure(state, action) {
      state.isPatchingContestant = false;
    },
    // ==== POST ====
    postContestant(state) {
      state.isPostingContestant = true;
    },
    postContestantSuccess(state, action) {
      state.isPostingContestant = false;
      state.contestants.data.push(action.payload);
      // state.rowConstestants.data.push(action.payload)
    },
    postContestantFailure(state) {
      state.isPostingContestant = false;
    },
    // ==== DELETE ====
    deleteContestant(state) {
      state.isDeletingContestant = true;
    },
    deleteContestantSuccess(state, action) {
      state.isDeletingContestant = false;
      // state.rowConstestants.data = state.rowConstestants.data.filter(c => c.id !== action.payload)
      // state.rowConstestants.total_count = state.rowConstestants.total_count - 1;
      // TODO
    },
    deleteContestantFailure(state) {
      state.isDeletingContestant = false;
    },

    // ==== ERASE ====
    eraseContestant(state) {
      state.isErasingContestant = true;
    },
    eraseContestantSuccess(state, action) {
      state.isErasingContestant = false;
      state.contestants = state.contestants.filter(
        (c) => c.id !== action.payload
      );
      state.contestants.total_count = state.contestants.total_count - 1;
      state.contestant.id = null;
      state.contestant.openModal = false;
      state.contestant.isLoading = false;
      state.contestant.data = null;
    },
    eraseContestantFailure(state) {
      state.isErasingContestant = false;
    },

    // ==== UPSERT ====
    upsertContestants(state) {
      state.isUpsertingContestants = true;
      state.insertedContestants = [];
      state.updatedContestants = [];
      state.notUpsertedContestants = [];
    },
    upsertContestantsSuccess(state) {
      state.isUpsertingContestants = false;
    },
    upsertContestantsFailure(state) {
      state.isUpsertingContestants = false;
    },
    upsertContestantFailure(state, action) {
      state.notUpsertedContestants.push(action.payload.contestant);
    },
    upsertContestantSuccess(state, action) {
      const { contestant, response } = action.payload;
      if (response.status === 201) {
        state.insertedContestants.push(response.data);
      } else {
        state.updatedContestants.push(contestant);
      }
      if (state.contestants) {
        const index = current(state).contestants.findIndex(
          (c) => c.id === contestant.id
        );
        if (index !== -1) {
          const previousIds = current(state).contestants[index].identifications;
          state.contestants = update(state.contestants, {
            [index]: {
              $set: {
                ...response.data,
                identifications: previousIds,
              },
            },
          });
        }
      }
    },
    // ==== DELETE ALL CONTESANTS ====
    deleteAllContestants(state) {
      state.isDeletingAllContestants = true;
      state.isDeletingAllContestantsSucceeded = false;
      state.isDeletingAllContestantsFailure = false;
    },
    deleteAllContestantsSuccess(state, action) {
      state.isDeletingAllContestants = false;
      state.isDeletingAllContestantsSucceeded = true;
      state.isDeletingAllContestantsFailure = false;
    },
    deleteAllContestantsFailure(state) {
      state.isDeletingAllContestants = false;
      state.isDeletingAllContestantsFailure = true;
      state.isDeletingAllContestantsSucceeded = false;
    },
    // =================================================
    getContestant(state, action) {
      state.contestant.id = action.payload;
      state.contestant.openModal = true;
      state.contestant.isLoading = true;
    },
    getContestantSuccess(state, action) {
      state.contestant.isLoading = false;
      state.contestant.data = action.payload;
      state.contestant.error = null;
    },
    getContestantFailure(state, action) {
      state.contestant.error = action.payload;
      state.contestant.isLoading = false;
    },
    closeAthleteModal(state) {
      state.contestant.id = null;
      state.contestant.openModal = false;
      state.contestant.isLoading = false;
      state.contestant.data = null;
      state.contestant.error = null;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getContestants(
  albumId,
  offset = 0,
  limit = 100,
  bibOrLastNameSearch = null
) {
  return async () => {
    try {
      dispatch(slice.actions.getContestants());
      const response = await axios.get(
        `/api/v1/photograph_albums/${albumId}/contestants`,
        {
          params: {
            bib_or_last_name: bibOrLastNameSearch,
            offset,
            limit,
          },
        }
      );
      dispatch(slice.actions.getContestantsSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.getContestantsError(error));
    }
  };
}

export function patchContestant(albumId, contestantId, contestant) {
  return async () => {
    try {
      dispatch(slice.actions.patchContestant());
      let response = await axios.patch(
        `/api/v1/photograph_albums/${albumId}/contestants/${contestantId}`,
        { ...contestant }
      );
      dispatch(slice.actions.patchContestantSuccess(response.data));
      dispatch(
        openSnackbar({
          open: true,
          message: <FormattedMessage id="contestant.updated" />,
          variant: "alert",
          alert: {
            color: "success",
          },
          close: false,
        })
      );
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.patchContestantFailure(error));
    }
  };
}

export function postContestant(albumId, contestant) {
  return async () => {
    try {
      dispatch(slice.actions.postContestant());
      const response = await axios.post(
        `/api/v1/photograph_albums/${albumId}/contestants`,
        { ...contestant }
      );
      dispatch(slice.actions.postContestantSuccess(response.data));
      dispatch(
        openSnackbar({
          open: true,
          message: <FormattedMessage id={"contestant.created"} />,
          variant: "alert",
          alert: {
            color: "success",
          },
          close: false,
        })
      );
    } catch (error) {
      const errorCode = getErrorCode(error);
      console.error(error);
      dispatch(slice.actions.postContestantFailure(error));
      dispatch(
        openSnackbar({
          open: true,
          message: <FormattedMessage id={errorCode} />,
          variant: "alert",
          alert: {
            color: "error",
          },
          close: false,
        })
      );
    }
  };
}

export function upsertContestants(albumId, constestants) {
  return async (dispatch) => {
    // Ensure dispatch is passed as an argument
    try {
      dispatch(slice.actions.upsertContestants());
      const promises = constestants.map(
        (
          c,
          index // Add index argument to map function
        ) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              // Add setTimeout to introduce delay
              axios
                .post(
                  `/api/v1/photograph_albums/${albumId}/contestants/upsert`,
                  {
                    ...c,
                  }
                )
                .then((response) => {
                  console.log(response);
                  dispatch(
                    slice.actions.upsertContestantSuccess({
                      contestant: c,
                      response,
                    })
                  );
                  resolve(); // Resolve promise after dispatching
                })
                .catch((response) => {
                  console.log(response);
                  dispatch(
                    slice.actions.upsertContestantFailure({
                      contestant: c,
                      error: response,
                    })
                  );
                  reject(); // Reject promise after dispatching
                });
            }, index * 400); // Multiply index by delay time (400ms)
          })
      );
      await Promise.all(promises);
      dispatch(slice.actions.upsertContestantsSuccess());
    } catch (e) {
      console.log(e);
    }
  };
}

export function deleteContestant(albumId, contestantId) {
  return async () => {
    try {
      dispatch(slice.actions.deleteContestant());
      await axios.delete(
        `/api/v1/photograph_albums/${albumId}/contestants/${contestantId}`
      );
      dispatch(slice.actions.deleteContestantSuccess(contestantId));
      dispatch(
        openSnackbar({
          open: true,
          message: <FormattedMessage id={"contestant.deleted"} />,
          variant: "alert",
          alert: {
            color: "success",
          },
          close: false,
        })
      );
    } catch (error) {
      const errorCode = getErrorCode(error);
      console.error(error);
      dispatch(slice.actions.deleteContestantFailure(error));
      dispatch(
        openSnackbar({
          open: true,
          message: <FormattedMessage id={errorCode} />,
          variant: "alert",
          alert: {
            color: "error",
          },
          close: false,
        })
      );
    }
  };
}
// Erase delete identification + contestant when delete, delete only the contestant
export function eraseContestant(albumId, contestantId) {
  return async () => {
    try {
      dispatch(slice.actions.eraseContestant());
      await axios.delete(
        `/api/v1/photograph_albums/${albumId}/contestants/${contestantId}/erase`
      );
      dispatch(slice.actions.eraseContestantSuccess(contestantId));
      dispatch(
        openSnackbar({
          open: true,
          message: "Le participant et ses identifications ont été supprimés",
          variant: "alert",
          alert: {
            color: "success",
          },
          close: false,
        })
      );
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.eraseContestantFailure());
    }
  };
}

export function deleteContestants(albumId) {
  return async () => {
    try {
      dispatch(slice.actions.deleteAllContestants());
      await axios.delete(
        `/api/v1/photograph_albums/${albumId}/contestants/delete-or-clear`
      );
      dispatch(slice.actions.deleteAllContestantsSuccess());
      dispatch(
        openSnackbar({
          open: true,
          message: <FormattedMessage id={"contestant.deleted_all"} />,
          variant: "alert",
          alert: {
            color: "success",
          },
          close: false,
        })
      );
    } catch (error) {
      const errorCode = getErrorCode(error);
      console.error(error);
      dispatch(slice.actions.deleteAllContestantsFailure(error));
      dispatch(
        openSnackbar({
          open: true,
          message: <FormattedMessage id={errorCode} />,
          variant: "alert",
          alert: {
            color: "error",
          },
          close: false,
        })
      );
    }
  };
}

export function openAthleteModal(albumId, contestantId) {
  return async () => {
    dispatch(slice.actions.getContestant(contestantId));
    try {
      const response = await axios.get(
        `/api/v1/photograph_albums/${albumId}/contestants/${contestantId}`
      );
      dispatch(slice.actions.getContestantSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.getContestantFailure(error));
    }
  };
}

export function closeAthleteModal() {
  return async () => {
    dispatch(slice.actions.closeAthleteModal());
  };
}

export function getPrevAthleteModal(albumId) {
  return async (_, getState) => {
    const contestantId = getState().contestants.contestant.id;
    const oldParams = getState().contestants.params;
    const index = getState().contestants.contestants.findIndex(
      (contestant) => contestant.id === contestantId
    );
    let backContestantId = null;
    let data = getState().contestants.contestants;
    if (index < 0) {
      throw new Error("Unknown");
    }
    if (index === 0) {
      const newParams = {
        ...oldParams,
        offset: oldParams.offset - oldParams.limit,
      };
      //TODO
      if (newParams.offset < 0) {
        dispatch(
          openSnackbar({
            open: true,
            message: "Il n'y a pas de photos précédentes ...",
            variant: "alert",
            alert: {
              color: "warning",
            },
          })
        );
        return;
      }
      dispatch(
        openSnackbar({
          open: true,
          message: "Chargement de la nouvelle page en cours ...",
          variant: "alert",
          alert: {
            color: "info",
          },
        })
      );
      const controller = getState().contestants.abortController;
      data = await _fetchContestants(dispatch, albumId, newParams, controller);
      backContestantId = data.data[data.data.length - 1].id;
    } else {
      backContestantId = data[index - 1].id;
    }
    dispatch(slice.actions.getContestant(backContestantId));
    try {
      const response = await axios.get(
        `/api/v1/photograph_albums/${albumId}/contestants/${backContestantId}`
      );
      dispatch(slice.actions.getContestantSuccess(response.data));
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.getContestantFailure(error));
    }
  };
}

export function getNextAthleteModal(albumId) {
  return async (_, getState) => {
    const contestantId = getState().contestants.contestant.id;
    const oldParams = getState().contestants.params;
    const index = getState().contestants.contestants.findIndex(
      (contestant) => contestant.id === contestantId
    );
    let nextContestantId = null;
    let data = getState().contestants.contestants;
    if (index < 0) {
      throw new Error("Unknown");
    }
    if (index === data.length - 1) {
      const newParams = {
        ...oldParams,
        offset: oldParams.offset + oldParams.limit,
      };
      dispatch(
        openSnackbar({
          open: true,
          message: "Chargement de la nouvelle page en cours ...",
          variant: "alert",
          alert: {
            color: "info",
          },
        })
      );
      const controller = getState().contestants.abortController;
      data = await _fetchContestants(dispatch, albumId, newParams, controller);
      nextContestantId = data.data[0].id;
    } else {
      nextContestantId = data[index + 1].id;
    }
    dispatch(slice.actions.getContestant(nextContestantId));
    try {
      const response = await axios.get(
        `/api/v1/photograph_albums/${albumId}/contestants/${nextContestantId}`
      );
      dispatch(slice.actions.getContestantSuccess(response.data));
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.getContestantFailure(error));
    }
  };
}

// ======= private functions =======

async function _fetchContestants(dispatch, albumId, params, controller) {
  try {
    dispatch(slice.actions.getContestants());
    dispatch(slice.actions.setPaginationParams(params));
    console.log(
      `request contestants : bib=${params.bib} identificationStatus=${params.identification_status} & aws_status=${params.aws_status} & tag_id=${params.tag_id} [offset=${params.offset} & limit=${params.limit}]`
    );
    const response = await axios.get(
      `/api/v1/photograph_albums/${albumId}/contestants`,
      {
        params: params,
        signal: controller ? controller.signal : null,
      }
    );
    dispatch(slice.actions.getContestantsSuccess(response.data));
    return response.data;
  } catch (error) {
    console.log(error);
    dispatch(slice.actions.getContestantsError(error));
    throw error;
  }
}
